import { Interface } from '@ethersproject/abi'
import CROSS_CHAIN_BRIDGE_ERC20_ABI from './CrossChainBridgeERC20.json'

const CROSS_CHAIN_BRIDGE_ERC20_INTERFACE = new Interface(CROSS_CHAIN_BRIDGE_ERC20_ABI)

export default CROSS_CHAIN_BRIDGE_ERC20_INTERFACE
export { CROSS_CHAIN_BRIDGE_ERC20_ABI }
